import { useTranslations } from "next-intl";
import { useState } from "react";
import { cn, hasText } from "@/lib/utils";
import CustomSwiper from "./CustomSwiper";
import VariableImage from "./ui/VariableImage";


const DrawerSection = ({
  mainTitle,
  title,
  text,
  time,
  img,
  slidesTitle,
  slides,
  logo,
}: {
  mainTitle: string;
  title: string;
  text: string;
  time: any[];
  img: {
    url: string;
    alternativeText: string;
    caption: string;
  };
  slidesTitle: string;
  slides: any[];
  logo?: {
    url: string;
    alternativeText: string;
    caption: string;
  };
}) => {
  const t = useTranslations("global");
  const [featured, setFeatured] = useState(t("view"));
  const [drawer, setDrawer] = useState(false);

  const handleFeature = () => {
    setFeatured((prev) => (prev === t("view") ? t("close") : t("view")));
  };

  const handleDrawer = () => {
    setDrawer(!drawer);
  };

  return (
    <div className="relative px-5">
      <h2 className="title-70 mb-10 px-5 font-semibold normal-case">
        {mainTitle}
      </h2>

      <div className="relative mb-20 flex w-full flex-wrap">
        <div className="relative aspect-video w-full overflow-hidden">
          <VariableImage
            src={img.url}
            width={1920}
            height={1080}
            className="absolute inset-0 size-full object-cover rtl:-scale-x-100"
            alt={img.alternativeText}
            caption={img.caption}
          />
        </div>

        <div className="relative z-1 w-full">
          <div className="blur-custom z-8 flex w-full flex-col items-start px-5 py-10 text-white">
            <button
              className="mx-auto mb-5 block h-2 w-20 rounded-full bg-gray"
              onClick={() => handleDrawer()}
              aria-label="Toggle details"
            ></button>
            <h3 className="title-30 capitalize! font-semibold leading-[120%]!">
              {title}
            </h3>
            <p
              className={cn(
                "mt-5 overflow-hidden whitespace-pre-line text-sm",
                drawer ? "block" : "hidden",
              )}
            >
              {text}
            </p>

            {time && time.length > 0 && (
              <div className="mt-5 text-sm capitalize">
                {time.map((item: any) => (
                  <p key={item.id}>{item.Text}</p>
                ))}
              </div>
            )}

            {slides.length > 1 && (
              <button
                className={cn(
                  "w-fit overflow-hidden capitalize underline transition-all duration-500 ease-in-out will-change-auto",
                  drawer ? "mt-5 h-[30px] opacity-100" : "h-0 opacity-0",
                )}
                onClick={() => {
                  handleFeature();
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "cta_button_click",
                    button_name: `${featured} ${t("featuredDishes")}`,
                    section: mainTitle,
                  });
                }}
              >
                {featured} {t("featuredDishes")}
              </button>
            )}
          </div>

          <div className="absolute inset-0 z-[-1] size-full">
            <VariableImage
              src={img.url}
              width={1920}
              height={1080}
              className="absolute inset-0 size-full object-cover"
              alt={img.alternativeText}
              caption={img.caption}
            />
          </div>
        </div>

        {logo && (
          <VariableImage
            src={logo.url}
            width={170}
            height={150}
            className="absolute inset-e-5 top-5 h-[20px] w-[100px] object-contain"
            alt={logo.alternativeText}
            caption={logo.caption}
          />
        )}
      </div>

      <div
        className={cn(
          "relative h-0 overflow-hidden px-5 opacity-0 transition-all duration-500 ease-in-out will-change-auto",
          featured === t("close")
            ? "h-[650px] opacity-100"
            : "pointer-events-none",
        )}
      >
        {hasText(slidesTitle) && (
          <h2 className="title-30 capitalize! mb-10 font-semibold">{slidesTitle}</h2>
        )}
        {slides.length > 1 && <CustomSwiper slides={slides} />}
      </div>
    </div>
  );
};

export default DrawerSection;
